import { MicrophoneMinusIcon } from './MicrophoneMinusIcon';

/**
 * author: Michael Richins
 * id FFAA9F2E-96F9-43A3-BC4E-F7562703E6A1
 * name microphone-minus
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microphone-minus.svg
 * tags
 */
export const MicrophoneRemoveIcon = MicrophoneMinusIcon;
export default MicrophoneRemoveIcon